import {
  Skeleton,
  SkeletonButton,
  SkeletonCard,
  SkeletonText,
  SkeletonTitle,
} from './SkeletonComponents';

export function ProfilePageSkeleton() {
  return (
    <div className="max-w-2xl mx-auto space-y-8">
      {/* Header */}
      <div>
        <SkeletonTitle className="w-32 h-9 mb-1" />
        <SkeletonText className="w-80 h-5" />
      </div>

      {/* Main Content Grid - exactly matching real component */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* Profile Information Card - Left Column */}
        <SkeletonCard>
          <SkeletonTitle className="w-40 h-6 mb-4" />

          {/* Form with space-y-4 */}
          <div className="space-y-4">
            {/* Name Field */}
            <div>
              <SkeletonText className="w-24 h-4 mb-2" />
              <Skeleton className="w-full h-10 rounded-md" />
            </div>

            {/* Email Field */}
            <div>
              <SkeletonText className="w-32 h-4 mb-2" />
              <Skeleton className="w-full h-10 rounded-md" />
              <SkeletonText className="w-64 h-3 mt-1" />
            </div>

            {/* Profile Picture Upload */}
            <div>
              <SkeletonText className="w-28 h-4 mb-2" />
              <Skeleton className="w-full h-32 rounded-lg" />
            </div>

            {/* Update Button - fullWidth */}
            <SkeletonButton className="w-full h-10" />
          </div>
        </SkeletonCard>

        {/* Right Column - Passkeys and Change Password with space-y-6 wrapper */}
        <div className="space-y-6">
          {/* Passkeys Card */}
          <SkeletonCard>
            <div className="flex items-center mb-4">
              <Skeleton className="w-5 h-5 mr-2" />
              <SkeletonTitle className="w-24 h-6" />
            </div>
            <SkeletonText className="w-full h-12 mb-4" />
            <SkeletonButton className="w-full h-10" />
          </SkeletonCard>

          {/* Change Password Card */}
          <SkeletonCard>
            <SkeletonTitle className="w-36 h-6 mb-4" />

            {/* Form with space-y-4 */}
            <div className="space-y-4">
              {/* Current Password */}
              <div>
                <SkeletonText className="w-32 h-4 mb-2" />
                <Skeleton className="w-full h-10 rounded-md" />
              </div>

              {/* New Password with space-y-2 wrapper */}
              <div className="space-y-2">
                <div>
                  <SkeletonText className="w-28 h-4 mb-2" />
                  <Skeleton className="w-full h-10 rounded-md" />
                </div>
                {/* Password Strength Indicator */}
                <Skeleton className="w-full h-4 rounded-md" />
              </div>

              {/* Confirm Password with space-y-2 wrapper */}
              <div className="space-y-2">
                <div>
                  <SkeletonText className="w-36 h-4 mb-2" />
                  <Skeleton className="w-full h-10 rounded-md" />
                </div>
                {/* Conditional Password Strength Indicator */}
                <Skeleton className="w-full h-4 rounded-md" />
              </div>

              {/* Change Password Button - fullWidth */}
              <SkeletonButton className="w-full h-10" />
            </div>
          </SkeletonCard>
        </div>
      </div>

      {/* Danger zone (account deletion) — full width, matching the grid */}
      <div className="mt-8">
        <SkeletonCard>
          <Skeleton className="w-40 h-5 mb-2" />
          <Skeleton className="w-64 h-3 mb-4" />
          <div className="space-y-2">
            <Skeleton className="w-full h-3" />
            <Skeleton className="w-5/6 h-3" />
            <Skeleton className="w-4/6 h-3" />
          </div>
          <SkeletonButton className="w-56 h-10 mt-4" />
        </SkeletonCard>
      </div>
    </div>
  );
}
